// import * as Config from '../../../../../config';
import React from 'react';

// import Menu from '../../../tab-bar/Menu';
import ButtonSampler from './ButtonSampler';

function TabBarMenus() {
  return (
    <>
      {/* <Menu to={`/home`} order={1} title={`Discover`} description={`Browse all genres by top tracks, DJ sets, DJ charts, ${Config.capAppName()} playlists, trending artists, trending labels and trending genres.`} /> */}
      {/* <Menu to={`/genres`} title={`Genres`} order={2} description={`Browse by genre: View top tracks in genre, ${Config.capAppName()} playlists in genre, trending artists in genre and trending labels in genre. Filter by favorite genres, featured releases in genre, all tracks in genre, all releases in genre and all playlists in genre.`} /> */}
      {/* <Menu to={`/featured-playlists`} order={3} title={`Playlists`} description={`Browse ${Config.capAppName()} Playlists.`} /> */}
      <div className={`flexRow`} style={{ position: 'absolute', right: 425, marginTop: 2.2 }}>
        <ButtonSampler />
      </div>
    </>
  )
}

export default TabBarMenus;
